<template>
  <TransitionGroup :name="name">
    <slot/>
  </TransitionGroup>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const { isBack = false } = defineProps<{
  readonly isBack?: boolean;
}>();

const name = computed(() => isBack ? "window-back" : "window-next");
</script>